import React from 'react'
import PropTypes from 'prop-types'
import { useFormContext, Controller } from 'react-hook-form'
import { Box, Typography } from '@material-ui/core'
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab'

import constants from 'constants/index'
import useStyles from './styles'

const ConsentDefaultSignalRow = ({ category }) => {
  const { control, watch } = useFormContext()

  const classes = useStyles()

  const { CONSENT_DEFAULT_OPTIONS } = constants.cookies.category

  const fieldName = `consentDefaultSignals.${category.key}`
  const signal = watch(fieldName)

  return (
    <Box className={classes.row}>
      <Typography variant="body2" className={classes.label}>
        {category.name}
      </Typography>
      <Controller
        control={control}
        name={fieldName}
        as={
          <ToggleButtonGroup
            exclusive
            size="small"
            aria-label={`Sinal inicial ao Google: ${category.name}`}
          >
            {CONSENT_DEFAULT_OPTIONS.map((option) => (
              <ToggleButton
                key={option.value}
                value={option.value}
                className={classes.option}
              >
                {option.label}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        }
        // Clicar no botão já marcado devolve null: o sinal continua o mesmo
        onChange={([, newSignal]) => (newSignal !== null ? newSignal : signal)}
      />
    </Box>
  )
}

ConsentDefaultSignalRow.propTypes = {
  category: PropTypes.shape({
    key: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
}

export default ConsentDefaultSignalRow
